import {selectPlayers} from "../../../redux/reducers/sharedStateReducer/selectors";
import {isPlayerFaction} from "../../factions/isPlayerFaction";
import {FACTIONS} from "../../../constants/factions";
import {LEPRECHAUNS_UNIT_SIZE_FOR_1_COIN_THEFT} from "../../../configs/factions/leprechauns";
import {checkIfUnitMovementProcessed} from "./checkIfUnitProcessed";

/**
 * Может ли отряд игрока-лепрекона украсть монеты на этапе перемещения: размер
 * не меньше порога кражи, отряд не перемещался и не крал в этом этапе (кража —
 * вместо перемещения), и хотя бы у одного противника есть монеты.
 */
export const checkIfUnitCanSteal = (state, unit, player) => {
  if (!isPlayerFaction(player, FACTIONS.LEPRECHAUNS)
    || unit.ownerId !== player.id
    || unit.size < LEPRECHAUNS_UNIT_SIZE_FOR_1_COIN_THEFT
    || checkIfUnitMovementProcessed(state, unit)
  ) {
    return false;
  }

  return selectPlayers(state).some((opponent) => opponent.id !== player.id && opponent.coins > 0);
};
